<template>
  <div>
      <div class="title">
        <van-image round width="22px" height="22px" fit="cover"  :src="payment.avatar" /> 
        <strong>{{payment.nickname}}</strong>
        <span>&nbsp;向您发起代付请求: </span>
      </div>
      <van-cell title="代付信息" :value="payment.paymentName"  value-class="value-class"/>
      <van-cell title="代付金额" :value="payment.actualCharge+'元'" />
      <br/>
      <van-notice-bar left-icon="info-o" v-show="payment && !payment.payable">{{payment.err}}</van-notice-bar>
      <div class="buttons">
        <van-button @click="pay" block type="primary" :disabled="loading && !payment || !payment.payable || timeout<1">帮TA付款 <span v-show="timeout>0">({{timeout|duration}})</span></van-button>
        <br />
        <van-button @click="exit" block>取消</van-button>
      </div>
  </div>
</template>

<script>
import { Button, CellGroup, NoticeBar, Image, Cell, Dialog } from 'vant';
import qs from 'query-string';
import { router } from '../router';
export default {
  components: {
    [Button.name]: Button,
    [Cell.name] : Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Image.name] : Image
  },
  data() {
    return {
      loading: false,
      payment : {},
      expirdTime: 0,
      timeout: 0,
      intervalId: null
    };
  },
  beforeDestroy(){
    clearInterval(this.intervalId);
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { tradeNo, paid } = qs.parse(location.search);
      if (paid == 'true') {
        Dialog.alert({
          title: '支付成功',
          message: "您已成功完成了好友的代付请求",
        }).then(()=>{
          this.exit();
        })
      } else {
        const http = this.$http;
        this.loading = true;
        const data = await http.get('/payment/payment_info', { tradeNo});
        this.loading = false;
        this.payment = data;
        this.payment.tradeNo = tradeNo;
        this.expirdTime = new Date().getTime() + (data.leftTime*1000);
        clearInterval(this.intervalId);
        this.intervalId = setInterval(() => {
          this.timeout = Math.ceil((this.expirdTime -new Date().getTime())/1000);
          if (this.timeout <= 0){
            clearInterval(this.intervalId);
            if(this.payment.payable && !this.payment.err){
              this.payment.payable = false;
              this.payment.err='支付信息已过期'
            }
          }
        }, 1000);
      }
      
    },
   exit(){
     this.$wechat.sdk(sdk => sdk.closeWindow());
   },
   async pay() {
     this.loading = true
     const agentTradeNo = await this.$http.post('/payment/pay_for_another', {tradeNo:this.payment.tradeNo}).then(x => x.result);
     const callback = window.location.pathname + window.location.search;
     router.push('/payment?tradeNo='+ agentTradeNo+'&callback=' + encodeURIComponent(callback)); 
   }
  }
};
</script>

<style lang="less" scoped>
.title {
  margin: 20px 10px;
  display: flex;
  align-items: center;
}
.buttons {
  padding: 10px;
  margin: 20px 0;
}
.value-class{
  flex: 4;
}
</style>